var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.thisOpened
    ? _c(
        "div",
        {
          staticClass: "popup",
          class: { "all-scroll": _vm.allScroll, visible: _vm.visible }
        },
        [
          _c("div", { ref: "captureBody", staticClass: "inner" }, [
            _vm.useHeader
              ? _c(
                  "div",
                  {
                    staticClass: "popup-header",
                    class: {
                      hasborder: _vm.useTopBorder,
                      "header-align-left": _vm.titalignLeft
                    }
                  },
                  [
                    _c("div", { staticClass: "popup-title" }, [
                      _c("h4", [_vm._v(_vm._s(_vm.$t(_vm.title)))]),
                      _c("button", {
                        staticClass: "btn-close",
                        attrs: { "data-html2canvas-ignore": "true" },
                        on: {
                          click: function($event) {
                            return _vm.cancelClick()
                          }
                        }
                      })
                    ]),
                    _c(
                      "div",
                      { staticClass: "description" },
                      [
                        _vm._t("subtitle", [
                          _vm._v(" " + _vm._s(_vm.subtitle) + " "),
                          _vm.subtitle2 ? _c("br") : _vm._e()
                        ]),
                        _vm._t("subtitle2", [
                          _vm._v(" " + _vm._s(_vm.subtitle2) + " "),
                          _vm.subtitle3 ? _c("br") : _vm._e()
                        ]),
                        _vm._t("subtitle3", [_vm._v(_vm._s(_vm.subtitle3))])
                      ],
                      2
                    )
                  ]
                )
              : _vm._e(),
            _vm.useBody
              ? _c(
                  "div",
                  {
                    staticClass: "popup-body",
                    class: [
                      { paddingbtm: !_vm.useFooter },
                      { "no-scroll-y": _vm.noBodyScroll }
                    ]
                  },
                  [
                    _vm._t("content"),
                    _vm.saveAndShare
                      ? _c("save-and-share", {
                          ref: "saveNShare",
                          attrs: {
                            "data-html2canvas-ignore": "true",
                            "popup.vue": ""
                          }
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm.useFooter
              ? _c(
                  "footer",
                  {
                    staticClass: "popup-footer",
                    class: {
                      hasborder: _vm.useBottomBorder,
                      "btn-padding": _vm.btnAreaPadding
                    },
                    attrs: { "data-html2canvas-ignore": "true" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-area--bottom" },
                      [
                        _vm._t("footer", [
                          _vm.noNegativeButton
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn bottom negative",
                                  on: { click: _vm.cancelClick }
                                },
                                [_vm._v(_vm._s(_vm.$t(_vm.cancel)))]
                              )
                            : _vm._e(),
                          _c(
                            "button",
                            {
                              staticClass: "btn bottom positive",
                              on: { click: _vm.confirmClick }
                            },
                            [_vm._v(_vm._s(_vm.$t(_vm.confirm)))]
                          )
                        ])
                      ],
                      2
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }